import { Component } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  submitting = false;
  submitSuccess = false;
  errorOnSubmit = false;

  forgotForm = new FormGroup({
    username: new FormControl('', Validators.required),
  });

  constructor(private authService: AuthService) {}

  forgot() {
    if (this.forgotForm.invalid) {
      return;
    }

    const username = this.forgotForm.value.username;

    if (username == null) {
      return;
    }

    this.submitting = true;
    this.submitSuccess = false;
    this.errorOnSubmit = false;

    this.authService.forgotPassword(username).subscribe({
      next: () => {
        this.submitting = false;
        this.submitSuccess = true;
      },
      error: () => {
        this.submitting = false;
        this.errorOnSubmit = true;
      }
    });
  }
}
